import React from 'react';
import { Modal } from 'antd';
import './index.less';
import { ABSButton } from '../ABSButton';
import ABSPerfectScrollBar from '../ABSPerfectScrollBar';
import classNames from 'classnames';
import { IABSModalProps, IABSModalStates } from './interface';
export { IABSModalProps } from './interface';

export class ABSModal extends React.Component<IABSModalProps, IABSModalStates> {
  static defaultProps = {
    okText: '确认',
    keyboard: true,
  };

  constructor(props: IABSModalProps) {
    super(props);
    this.state = {
      visible: false
    };    
  }

  onConfirm = () => {
    const { onConfirm } = this.props;
    if (onConfirm) {
      onConfirm();
    }    
  };

  onClose = () => {
    this.show(false);
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }   
  };

  show = (flag: boolean, callback?: () => void) => {
    this.setState({ visible: flag }, () => {
      if (flag) { // 当时弹窗打开时，锚点框(静止消失型)隐藏。（为解决弹框，下拉框，锚点z-index矛盾点）
        this.hideAnchorPoint();
      }
      if ( callback && typeof callback === 'function') {
        callback();
      }
    });
  }

  // 当时弹窗打开时，锚点框(静止消失型)隐藏。（为解决弹框，下拉框，锚点z-index矛盾点）
  hideAnchorPoint = () => {
    const anchorPoint: HTMLElement = document.querySelector('.abs-anchor-point.abs-anchor-point-static-hide') as HTMLElement;
    if (anchorPoint) {
      anchorPoint.style.display = 'none';
    }
  }

  renderFooter() {
    const { okText, footer } = this.props;
    return footer ? footer
      : footer === null ? null
        : [
          // tslint:disable-next-line:jsx-wrap-multiline
          <ABSButton
            key="submit"
            type="primary"
            onClick={this.onConfirm}
            absIcon="check"
          >
            {okText}
          </ABSButton>,
          // tslint:disable-next-line:jsx-wrap-multiline
          <ABSButton
            key="return"
            type="default"
            className="abs-btn-gap-left"
            onClick={this.onClose}
            absIcon="close"
          >
            取消
          </ABSButton>
        ];
      }

  render() {
    const {
      content,
      title,
      width,
      className,
      footer,
      destroyOnClose,
      wrapClassName,
      getContainer,
      maskClosable,
      closable,
      keyboard,
    } = this.props;
    const { visible } = this.state;
    // 防止width超界
    const modalWidth = (width && width > 0 && width <= 1040 ) ? width : 330;
    const classes = classNames('abs-modal', className);
    const containerClasses = classNames('abs-modal-body-scrollbar', {
      'abs-modal-body-nofooter-scrollbar': footer === null,
    });
    return (
        <Modal
          title={title}
          visible={visible}
          width={modalWidth}
          keyboard={keyboard}
          onCancel={this.onClose} 
          footer={this.renderFooter()}
          className={classes}
          closable={closable}
          maskClosable={maskClosable}
          destroyOnClose={destroyOnClose}
          wrapClassName={wrapClassName}
          getContainer={getContainer}
        >
          <ABSPerfectScrollBar>
            <div className={containerClasses}>
              <div>{content}</div>
            </div>
          </ABSPerfectScrollBar>
        </Modal>
    );
  }
}

export default ABSModal;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSModal/index.tsx